import clsx from 'clsx';
import CustomLink from './CustomLink';

export default function UnderlinedLink({
  to,
  className,
  isNotPrismic = false,
  underLineIsblack = false,
  onClick = null,
  children,
}: { 
  to?: string | null;
  className?: string;
  isNotPrismic?: boolean;
  underLineIsblack?: boolean;
  onClick?: (() => void) | null;
  children: React.ReactNode;
}) {
  return (
    <span className="relative pb-1 overflow-hidden leading-none group">
      {isNotPrismic ? (
        <a href={to ?? undefined} target="_blank" rel="noopener noreferrer" className={clsx(className, 'peer')}>
          {children}
        </a>
      ) : (
        <CustomLink to={to} className={clsx(className, 'peer')} onClick={onClick ?? undefined}>
          {children}
        </CustomLink>
      )}
      <span
        className={clsx(
          'absolute bottom-0 left-0 w-full h-px transition-transform origin-right scale-x-0 peer-hover:scale-x-100 peer-hover:origin-left',
          underLineIsblack ? 'bg-black' : 'bg-white'
        )}
      ></span>
    </span>
  );
}
